import React, { useState } from 'react'
import { getStudents, getStudentsByCourse } from '../../firebase/utils'
import Context from './index'
import { studentData } from '../../Data'
import { getStudentsFromV9 } from '../../firebase'

const StudentProvider = (props) => {
    const [loading, setLoading] = useState(true)
    const [students, setStudents] = useState([])
    const [allstudent,setAllstudent]=useState([])

    const fetchStudents = async (course) => {
        setLoading(true)
        try {
            const data = await getStudentsByCourse(course.id)
            setStudents(data)
        } catch (error) {
            console.log('fetching students::', error)
        }
        setLoading(false)
    }
    const fetchAllStudents = async () => {
        try {
            const data = await getStudentsFromV9()
            if (JSON.stringify(data) !== JSON.stringify(allstudent)) {
                setAllstudent(data);
            }
            return data;
        } catch (error) {
            console.log('fetching students::', error)
        }
    }

    return (
        <Context.Provider
            value={{
                loading,
                setLoading,
                fetchStudents,
                fetchAllStudents,
                setStudents,
                students,
                allstudent,
                setAllstudent
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export default StudentProvider